import { OEM_CONSTANTS } from "../constants/oemConstants";

// Action Creators
export const addOemRequest = () => ({
  type: OEM_CONSTANTS.ADD_OEM_REQUEST,
});

export const addOemSuccess = (data) => ({
  type: OEM_CONSTANTS.ADD_OEM_SUCCESS,
  payload: data,
});

export const addOemFailure = (error) => ({
  type: OEM_CONSTANTS.ADD_OEM_FAILURE,
  payload: error,
});

export const getOemRequest = () => ({
  type: OEM_CONSTANTS.GET_OEM_REQUEST,
});

export const getOemSuccess = (data) => ({
  type: OEM_CONSTANTS.GET_OEM_SUCCESS,
  payload: data,
});

export const getOemFailure = (error) => ({
  type: OEM_CONSTANTS.GET_OEM_FAILURE,
  payload: error,
});

// Saga Actions
export const addOemPartner = (data) => ({
  type: "ADD_OEM_SAGA",
  payload: data,
});

export const getOemPartners = (params) => ({
  type: "GET_OEM_SAGA",
  payload: params,
});

export const editOemPartner = (data) => ({
  type: "EDIT_OEM_SAGA",
  payload: data,
});

export const deleteOemPartner = (id) => ({
  type: "DELETE_OEM_SAGA",
  payload: id,
});

export const changeOemStatus = (data) => ({
  type: "CHANGE_OEM_STATUS_SAGA",
  payload: data,
});

export const resetOemPassword = (data) => ({
  type: "RESET_OEM_PASSWORD_SAGA",
  payload: data,
});
export const resetOemState = () => ({
  type: "RESET_OEM_STATE",
});

export const getScanTypes = () => ({
  type: "GET_SCAN_TYPES_SAGA",
});

export const getScanTypesSuccess = (data) => ({
  type: OEM_CONSTANTS.GET_SCAN_TYPES_SUCCESS,
  payload: data,
});

export const getScanTypesFailure = (error) => ({
  type: OEM_CONSTANTS.GET_SCAN_TYPES_FAILURE,
  payload: error,
});

export const getOemNames = () => ({
  type: "GET_OEM_NAMES_SAGA",
});

export const getOemNamesSuccess = (data) => ({
  type: OEM_CONSTANTS.GET_OEM_NAMES_SUCCESS,
  payload: data,
});

export const getOemNamesFailure = (error) => ({
  type: OEM_CONSTANTS.GET_OEM_NAMES_FAILURE,
  payload: error,
});

export const getOemPartnerRequest = (id) => ({
  type: "GET_OEM_PARTNER_SAGA",
  payload: id,
});

export const getLicenses = (params) => ({
  type: "GET_LICENSES_SAGA",
  payload: params,
});

export const getLicensesSuccess = (data) => ({
  type: OEM_CONSTANTS.GET_LICENSES_SUCCESS,
  payload: data,
});

export const getLicensesFailure = (error) => ({
  type: OEM_CONSTANTS.GET_LICENSES_FAILURE,
  payload: error,
});

export const getLicensesList = (params) => ({
  type: "GET_LICENSES_LIST_SAGA",
  payload: params,
});

export const getLicensesListSuccess = (data) => ({
  type: OEM_CONSTANTS.GET_LICENSES_LIST_SUCCESS,
  payload: data,
});

export const getLicensesListFailure = (error) => ({
  type: OEM_CONSTANTS.GET_LICENSES_LIST_FAILURE,
  payload: error,
});

export const getOemPartnerUsers = (params) => ({
  type: "GET_OEM_PARTNER_USERS_SAGA",
  payload: params,
});

export const getOemPartnerUsersSuccess = (data) => ({
  type: OEM_CONSTANTS.GET_OEM_PARTNER_USERS_SUCCESS,
  payload: data,
});

export const getOemPartnerUsersFailure = (error) => ({
  type: OEM_CONSTANTS.GET_OEM_PARTNER_USERS_FAILURE,
  payload: error,
});
